<template>
  <button
    :class="[
      'c-button',
      'button',
      theme === 'dark' ? 'button--dark' : 'button--light',
      !hasIcon ? 'button--no-icon' : '',
    ]"
    :data-animation="isAnimated ? 'button' : false"
  >
    <span class="button__bg" :data-animated="!isAnimated"/>
    <router-link
      :to="data.url"
      v-if="router"
      @mouseenter.native="isHoverable ? $eventHub.$emit('morphCursor', 'circle') : false"
      @mouseleave.native="isHoverable ? $eventHub.$emit('morphCursor', 'rect') : false"
    >
      <span>
        {{ data.content }}
      </span>
      <!-- <svg viewBox="0 0 10 10">
        <circle cx="5" cy="5" r="3" />
        <polyline points="4.7,4.1 5.6,5 4.7,6 " />
      </svg> -->
      <svg viewBox="0 0 38 38" v-if="hasIcon">
        <circle cx="19" cy="19" r="18"/>
        <g v-if="inMenu">
          <circle cx="24.5" cy="16" r="2"/>
          <circle cx="14" cy="16" r="2"/>
          <path
            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
            d="M25,23c0,3.3-2.7,6-6,6s-6-2.7-6-6"
          />
        </g>
        <path
          v-else
          stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
          d="M17,14.5l4.5,4.5L17,23.5"
        />
      </svg>
    </router-link>
    <a
      v-else
      :href="data.url"
      @mouseenter="isHoverable ? $eventHub.$emit('morphCursor', 'circle') : false"
      @mouseleave="isHoverable ? $eventHub.$emit('morphCursor', 'rect') : false"
      :target="!newView ? false : '_blank'"
      :rel="!newView ? false : 'noopener'"
    >
      <span>
        {{ data.content }}
      </span>
      <svg viewBox="0 0 38 38" v-if="hasIcon">
        <circle id="Oval" class="st0" cx="19" cy="19" r="18"/>
        <g v-if="inMenu">
          <circle class="st1" cx="24.5" cy="16" r="2"/>
          <circle class="st1" cx="14" cy="16" r="2"/>
          <path
            stroke-linecap="round" stroke-linejoin="round"
            d="M25,23c0,3.3-2.7,6-6,6s-6-2.7-6-6"
          />
        </g>
        <path
          v-else
          stroke-linecap="round" stroke-linejoin="round"
          d="M17,14.5l4.5,4.5L17,23.5"
        />
      </svg>
    </a>
  </button>
</template>

<script>
export default {
  name: 'AppButton',
  props: {
    data: {
      type: Object,
      required: true,
    },
    router: {
      type: Boolean,
      required: false,
      default: true,
    },
    newView: {
      type: Boolean,
      required: false,
      default: true,
    },
    hasIcon: {
      type: Boolean,
      required: false,
      default: true,
    },
    theme: {
      type: String,
      required: false,
      default: 'light',
    },
    isAnimated: {
      type: Boolean,
      required: false,
      default: true,
    },
    isHoverable: {
      type: Boolean,
      required: false,
      default: true,
    },
    inMenu: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.button {
  position: relative;

  background-color: transparent;
  border: 0;

  font-size: 16px;

  @include mq($from: dm) {
    font-size: 20px;
  }

  @include mq($from: dxl) {
    font-size: 24px;
  }

 &__bg {
    content: '';

    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    border-radius: 40px;

    @include mq($from: dm) {
      border-radius: 80px;
    }

    @include mq($from: dxl) {
      border-radius: 80px;
    }
  }

  a {
    display: block;
    padding: 16px 20px 16px 40px;

    @include mq($from: dm) {
      padding: 20px 30px 20px 42px;
    }

    @include mq($from: dxl) {
      padding: 26px 37px 26px 55px;
    }

    span {
      display: inline-block;
    }

    svg {
      width: 10px;
      height: 10px;
      margin-left: 15px;

      circle,
      path {
        stroke-width: 2;
        fill: none;
      }

      > path {
        fill: none;
        stroke-width: 2;

        clip-path: inset(0 0 0 100%);
        transition: clip-path 0.35s $outBack;
      }

      > g {
        transform: scale(0);
        transform-origin: 50% 50%;
        transition: transform 0.35s $outBack;
      }
    }
  }

  & .button__bg[data-animated],
  svg,
  & a span {
    transition: transform 0.35s $outBack;
  }

  &.button--light {
    & .button__bg {
      background-color: var(--color-headline-light);
    }

    a {
      color: var(--color-headline-dark);
    }

    svg circle,
    svg path {
      stroke: var(--color-headline-dark);
    }

    svg g circle {
      stroke-width: 0;
      fill: var(--color-headline-dark);
    }
  }

  &.button--dark {
    & .button__bg {
      background-color: var(--color-headline-dark);
    }

    a {
      color: var(--color-headline-light);
    }

    svg circle,
    svg path {
      stroke: var(--color-headline-light);
    }

    svg g circle {
      stroke-width: 0;
      fill: var(--color-headline-light);
    }
  }

  @include mq($and: $is-not-touch-device) {
    &:hover {
      & .button__bg {
        transform: scale(1.2);
      }

      span {
        transform: translateX(-20px);
      }

      svg {
        transform: scale(4);

        circle {
          stroke-width: 1.5;
        }

        > path {
          clip-path: inset(0 -10px 0 0);
          transition: clip-path 0.35s $outBack 0.1s;
        }

        > g {
          transform: scale(1);
          transition: transform 0.35s $outBack 0.1s;
        }
      }
    }
  }


  @include mq($and: $is-touch-device) {
    & .button__bg {
      transform: scale(1.2);
    }

    a span {
      transform: translateX(-20px);
    }

    a svg {
      transform: scale(4);

      circle {
        stroke-width: 1.5;
      }

      path,
      > g {
        transform: scale(1);
        clip-path: inset(0 0 0 0);
        transition: clip-path 0.35s $outBack 0.1s;
      }
    }
  }

  &.button--no-icon {
    a {
      padding: 18px 20px;
    }

    span {
      transform: none;
    }
  }

  @at-root [data-city="toronto"] & {
    &.button--light {
      & .button__bg {
        background-color: var(--color-cursor);
      }

      a {
        color: var(--color-headline-light);
      }

      svg circle,
      svg path {
        stroke: var(--color-headline-light);
      }

      svg g circle {
        stroke-width: 0;
        fill: var(--color-headline-light);
      }
    }

    &.button--dark {
      & .button__bg {
        background-color: var(--color-headline-light);
      }

      a {
        color: var(--color-cursor);
      }

      svg circle,
      svg path {
        stroke: var(--color-cursor);
      }

      svg g circle {
        stroke-width: 0;
        fill: var(--color-cursor);
      }
    }
  }
}
</style>
